module.exports = __webpack_public_path__ + "images/avatars/female/19.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/19.png
// module id = 0eTi
// module chunks = 154